import tempMeeApi from '../../../apis/tempMee';

export const getACHAuthorizationRecords = async (userId) => {
  const response = await tempMeeApi.get(
    `/payment/admin/account/payment-method/${userId}/authorization-record`,
  );

  return response.data;
};
